export default {
    SIGNED: 1,
    REQUESTED: 2,
    NA: 3,
    TEMPORARY: 7,
    UNDO_SIGNED: 4,
    UNDO_REQUESTED: 5,
    UNDO_NA: 6,
    UNDO: 999
}